import React, { useEffect, useState } from "react";
import {
  backendGetRequest,
  backendPostWithoutRefresh,
} from "../../helpers/callBackend";
import StyledSelect from "./StyledSelect";

const CompanySelectV2 = (props) => {
  const [switchRequested, setSwitchRequested] = useState(false);
  const [companiesArray, setCompaniesArray] = useState([]);
  const [currentCompany, setCurrentCompany] = useState({
    value: "",
    display_text: "",
  });

  const getUcsObjects = async () => {
    const ucsResp = await backendGetRequest("/api/user/user-company-settings");
    if (ucsResp.status != 200) {
      return;
    }
    const newCompaniesArray = ucsResp.data.data.all_ucs.map((item) => ({
      display_text: item.company_name,
      value: item.company,
    }));
    setCompaniesArray(newCompaniesArray);
    setCurrentCompany({
      value: ucsResp.data.data.active_ucs.company,
      display_text: ucsResp.data.data.active_ucs.company_name,
    });
  };

  const onSelectNewCompany = (event) => {
    const newCompanyId = event.target.value;
    const newCompany = companiesArray.find(
      (ucsObject) => ucsObject.value == newCompanyId
    );
    if (newCompany) {
      setCurrentCompany(newCompany);
      setSwitchRequested(true);
    }
  };

  const switchCompanyDashboard = async (newCompanyId) => {
    const switchResp = await backendPostWithoutRefresh(
      "/api/landlord/switch/",
      { landlord_id: newCompanyId }
    );

    if (switchResp.status == 200) {
      window.location.href = "/login-redirect";
    }
  };

  useEffect(() => {
    getUcsObjects();
  }, []);

  useEffect(() => {
    if (!switchRequested) {
      return;
    }
    switchCompanyDashboard(currentCompany.value);
  }, [currentCompany]);

  return (
    <StyledSelect
      items={companiesArray}
      value={companiesArray.length ? currentCompany.value : ""}
      formWidth={props.width ? props.width : "100%"}
      onChange={(event) => onSelectNewCompany(event)}
    />
  );
};

export default CompanySelectV2;
